import { DocScanJobDetail } from "models";

/**
 * Reads the number of scanned fields carrying a given overall status.
 * @param docScan - The scan job detail, or `undefined` while it is still loading.
 * @param status - The overall status to count, e.g. `match` or `need_review`.
 * @returns The count for that status, or `0` when the scan has no statistics yet.
 */
export const getOverallStatusCount = (docScan: DocScanJobDetail | undefined, status: string): number => {
  // The API only ever stores the raw comparison status; "need_review" is a client-side alias for "ambiguous".
  const dbStatus = status === "need_review" ? "ambiguous" : status;
  return docScan?.statistics?.overallStatusGroups.find((g) => g.overallStatus === dbStatus)?.count ?? 0;
};
